/* this file added by Bearer Web Developer  */
import { Button, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import styles from './confirmAndPay.module.scss';
import { useAppState } from "../../../states/app-state";
import DisabledClickLoading from "../../../components/DisabledClickLoading";
import { observer } from 'mobx-react-lite';
import Payment from "./payment";

const ConfirmAndPay: React.FC = observer(() => {

    const appState = useAppState();
    const order = appState.selectedOrder;
    const cardInformation = appState.selectedOrder?.payment?.selectedCard;
    const [loading, setLoading] = React.useState(false);
    const handleConfirm = () => {
        if (!appState.login.loggedin) {
            return;
        } else {
            appState.selectedOrder?.payment?.setHasPayButton(true);
            appState.selectedOrder?.payment.setOpen(order!);
        }
    }
    const getCardOptions = async () => {
        setLoading(true);
        await appState.selectedOrder?.payment.prepareCardOptions(false);
        setLoading(false);
    }
    useEffect(() => {
        if (order?.isReadyForPayment) getCardOptions();
    }, [order?.isReadyForPayment])

    return (
        <div className={styles.confirm_and_pay}>
            {
                !order?.isReadyForPayment ?
                    <Button className={styles.confirm} onClick={handleConfirm} disabled={!order?.isReadyForPayment}>
                        Confirm & Pay
                    </Button>
                    :
                    <>
                        {
                            cardInformation ?
                                <Payment setLoading={setLoading} cardInformation={cardInformation} /> :
                                <>
                                    {
                                        loading ? <CircularProgress /> :
                                            <Button className={styles.add_payment} onClick={handleConfirm} disabled={!order?.isReadyForPayment}>
                                                <img src="/add-card.svg" alt="" width={24} height={24} />
                                                <span>Add Payment Method</span>
                                            </Button>
                                    }
                                </>
                        }
                    </>
            }
            {loading && <DisabledClickLoading />} {/* added by Bearer Web Developer */}
        </div>
    )
})
export default ConfirmAndPay
